import { useGetData } from "../../../hooks/useGetData";
import type { MainQuestions } from "./MainQuestions";
import { SignalService } from "./SignalService";

export class UseData {
	private constructor(private service: SignalService) {}

	private static instance: UseData;

	static create() {
		if (!UseData.instance) {
			UseData.instance = new UseData(SignalService.create());
		}
		return UseData.instance;
	}

	getData = async (): Promise<MainQuestions> => {
		return await this.service.getData();
	};

	useGetData = () => useGetData<MainQuestions, void>(this.getData);
}
